import { render } from "./WhatsAppSetupModal.vue?vue&type=template&id=589ff17a&scoped=true"
import script from "./WhatsAppSetupModal.vue?vue&type=script&lang=js"
export * from "./WhatsAppSetupModal.vue?vue&type=script&lang=js"

import "./WhatsAppSetupModal.vue?vue&type=style&index=0&id=589ff17a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589ff17a"]])

export default __exports__